import React from 'react';
import dynamic from 'next/dynamic';
import { useRecentlyViewed } from '@/lib/use-recently-viewed';
import Section from '../commons/Section';

const Deals = dynamic(() => import('@/components/homepage/Deals'), {
  ssr: false,
});

const PopularCategories = dynamic(
  () => import('@/components/commons/PopularCategories'),
  { ssr: false },
);

const RecentlyViewed = dynamic(
  () => import('@/components/homepage/RecentlyViewed'),
  { ssr: false },
);

function AccountRecommendations() {
  const [recentlyViewed, fetchingRecentlyViewed] = useRecentlyViewed();

  return (
    <Section className="border border-t-2 border-gray-100 bg-white">
      <Deals />
      <div className="reebelo-container">
        <RecentlyViewed
          recentlyViewed={recentlyViewed}
          fetching={fetchingRecentlyViewed}
          isHomepage
          isAccount
        />
        <PopularCategories />
      </div>
    </Section>
  );
}

export default AccountRecommendations;
